import { serverIp, } from '../../../../config/constants.js'
import axios from 'axios'


export function udpateIndyOrderDetails(indyOrderKey, mainOrderKey, itemToUpdate, valueToUpdate, userEmail) {
    console.log("+++++++++: udpateIndyOrderDetails");
    console.log("indyOrderKey:"+indyOrderKey);
    console.log("mainOrderKey:"+mainOrderKey);
    console.log("itemToUpdate:"+itemToUpdate);
    console.log("valueToUpdate:"+valueToUpdate);


    //NET WORK CALL
    axios.post(serverIp + 'orders/udpateIndyOrderDetails', {
        fbOrderKey: mainOrderKey,
        indyOrderKey: indyOrderKey,
        itemToUpdate: itemToUpdate,
        valueToUpdate: valueToUpdate,
        adminEmail: userEmail,
    })
        .then((response) => {
            console.log(response.data);

        })
        .catch((error) => {
            console.log(error);
        });
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ServerUtils/ServerUtils.js